module.exports = __webpack_public_path__ + "assets/snow-textures-5.230efbd02543beac94672cd23fc75cb3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./imgs/snow-textures-5.jpg
 ** module id = 182
 ** module chunks = 0
 **/